import { Text } from '@scale/scaleui-radix';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';
import { useProjectId } from 'react-scale/corp/views/CorpProjectGroupManager/hooks/useProjectId';
import { useQuickGrabTasksByReviewLevel } from 'react-scale/corp/views/CorpProjectGroupManager/communication/apiClient';
import { QuickGrabContent } from 'react-scale/corp/views/CorpProjectGroupManager/components/QuickGrab/QuickGrabContent';
import { QuickGrabTasksResponse } from '@scale/shared/quickGrab/types';

export function QuickGrabMagicSearch() {
  const quickGrabEnabled = useUnleashFeatureFlag('ops-hub-quick-grab', {}, false);
  const projectId = useProjectId();
  const { data: quickGrabData, isLoading } = useQuickGrabTasksByReviewLevel(projectId) as {
    data: QuickGrabTasksResponse;
    isLoading: boolean;
  };

  // Determine if the Quick Grab section should be shown
  const showQuickGrab = quickGrabEnabled && projectId && quickGrabData && !isLoading;

  if (!showQuickGrab) {
    return null; // Don't render anything if conditions aren't met
  }

  return (
    <div className="p-4 border-t border-neutral-200">
      {' '}
      {/* Added border for separation */}
      <div className="pb-4">
        <Text size="5">Quick Grab Tasks</Text>
      </div>
      <QuickGrabContent
        data={quickGrabData}
        isLoading={isLoading}
        projectId={projectId}
        enableKeyboardShortcuts={true} // Assuming keyboard shortcuts should be enabled when shown in Magic Search
      />
    </div>
  );
}
